<template>
  <v-menu offset-y open-on-hover>
    <template v-slot:activator="{ on }">
      <v-btn fab small outline v-on="on" class="ml-1 extra-small" color="primary">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        v-for="(item, index) in intents"
        :key="index"
        @click="$emit('addIntentPrefill', item.value)"
      >
        <v-list-tile-title class="primary-color">{{ item.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data: function() {
    return {
      isShow: true,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      search: '',
      intents: [
        {
          name: this.$t('Insert') + this.$t('first name'),
          value: 'first_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('last name'),
          value: 'last_name',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Message'),
          value: 'msg',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Variable'),
          value: 'variable',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Date'),
          value: 'date',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Time'),
          value: 'time',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('Location'),
          value: 'location',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('video'),
          value: 'video',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('audio'),
          value: 'audio',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('image'),
          value: 'image',
          description: ''
        },
        {
          name: this.$t('Insert') + this.$t('sticker'),
          value: 'sticker',
          description: ''
        }
      ]
    }
  },
  mounted: function() {
    // document.addEventListener('click', this.documentClick)

    var vm = this
  },
  computed: {
    filterIntents: function() {
      var vm = this
      return vm.intents.filter(intent => {
        return intent.name.toLowerCase().includes(vm.search.toLowerCase())
      })
    }
  },
  methods: {},
  destroyed() {
    // important to clean up!!
    // document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style scoped>
.z-dropdown .dropdown-content {
  transform-origin: 0px 0px;
  opacity: 1;
  transform: scaleX(1) scaleY(1);
}
.z-dropdown a {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/flow/IntentManagePrefill.vue